import React from 'react';
import { FaFilePdf } from 'react-icons/fa';
import './style.css';

class Footer extends React.Component {
  render() {
    return (
      <footer id="footer">
        <div className="footer-content">
          <div className="footer-top">
            <div className="footer-left">
              <div className="logo-container">
                <img
                  src="/logo-memnon.png"
                  alt="Memnon Logo"
                  className="memnon-logo"
                />
              </div>
            </div>
            <div className="footer-center">
              <div className="contact-info">
                <p className="address">
                  Avenida Dermival Bernardes Siqueira 3630 – Lojas 3 e 4 – Swiss
                  Park – Campinas – SP
                </p>
                <div className="contact-details">
                  <p className="contact-title">Fale conosco:</p>
                  <p>
                    • atendimento de segunda a sexta-feira, das 9h00 às 19h00
                  </p>
                  <p>
                    • e-mail:{' '}
                    <a
                      href="mailto:lojavirtual@memnon.com.br"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      lojavirtual@memnon.com.br
                    </a>
                  </p>
                  <p>
                    • telefone:{' '}
                    <a
                      href="tel:(19) 3278-3918"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      (19) 3278-3918
                    </a>
                  </p>
                  <p>
                    • whatsApp:{' '}
                    <a
                      href="https://wa.me/5511944841558"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      (11) 9-4484-1558
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="footer-right">
              <div className="icon-link">
                <FaFilePdf color="#fff" size={36} />
                <p>
                  <a
                    href="/pdf/manual-stroop.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Manual Stroop App
                    <br />
                    (download)
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p className="copyright">© 2025 Memnon Edições Científicas Ltda.</p>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
